<template>
  <v-dialog
    v-model="active"
    @click:outside="$emit('close')"
    width="700"
  >
    <v-card style="padding:20px 50px">
      <i class="mdi mdi-close close-icon" @click="$emit('close')"></i>
      <v-card-title class="d-flex flex-column align-items-center justify-content-center">
        <h4  style="color:var(--medium-blue)"> <i class="mdi mdi-alert"></i> Alerta !</h4> 
        <small>Operação irreverssível</small>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <p class="text-center"> 
          Deseja remover este animal do serviço ?
        </p>
      </v-card-text>
      <v-card-actions class="d-flex justify-content-center">
        <v-btn outlined class="btn-back mx-1" @click="$emit('close')">Voltar</v-btn>
        <v-btn class="success mx-1" @click="$emit('save')">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name:"ModalAlertServiceDelete",
  props:{
    active:Boolean,
  }
}
</script>

<style scoped>
  .close-icon {
    right: 50px;
    position: absolute;
    font-size: 1.3rem;
    cursor: pointer;
  }
</style>